export const Role = {
    Admin: 'cd4d4778-a34c-4a21-8ed6-039218ecc63c',
    User: '70ce9309-abb1-4afb-9e02-b2288fb86ba2'
}